<template lang="html">
    <div class="page-subtitle">
        <div class="container">
            <span v-if="iconClass" class="icon" :class="iconClass"></span>
            <h1>{{title}}</h1>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false
        }
    },
    computed: {
        iconClass() {
            return (this.icon) ? 'icon-' + this.icon : false;
        }
    }
};
</script>

<style lang="less">
@import '../../less/variables';

.page-subtitle {
    display: block;
    position: relative;
    .container {
        padding: 1em 0;
        max-width: none;
    }
    .icon {
        display: inline-block;
        vertical-align: middle;
        font-size: 50px;
        margin-right: 20px;
        margin-left: 2px;
        color: @color-1;
    }
    h1 {
        display: inline-block;
        vertical-align: middle;
        color: @color-1;
        font-size: 20px;
        line-height: 20px;
        margin-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/page-subtitle.vue